import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

import { MAX_SELECTED_SYMBOLS } from '@/constants/constants';

const LimitDialog = ({ handleClose, open }: { handleClose: () => void; open: boolean }) => {
  return (
    <Dialog
      aria-describedby='alert-dialog-description'
      aria-labelledby='alert-dialog-title'
      open={open}
      sx={{ backgroundColor: '#2634c866' }}
      onClose={handleClose}
    >
      <DialogContent
        sx={{ backgroundColor: 'background.default', pb: '16px', pt: '24px', px: '24px' }}
      >
        <DialogContentText
          id='alert-dialog-description'
          sx={{ color: 'text.primary', width: 500 }}
        >
          Too many items!
        </DialogContentText>
        <DialogContentText sx={{ color: 'text.primary' }}>
          Please select fewer than {MAX_SELECTED_SYMBOLS}.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: 'background.default', px: '36px', pb: '24px', pt: 0 }}>
        <Button
          sx={{ m: 0, width: 120 }}
          variant='contained'
          onClick={handleClose}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LimitDialog;
